module.exports = __webpack_public_path__ + "img/kkb_hdmiboost.cda052e0.jpg";